import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';
import { WysiwygField } from '../../../../components';

import './style.scss';

const TaxonomyTermThemeTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'Theme', 'TaxonomyTerm', 'TaxonomyTermThemeTeaser');

  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['description', 0, 'processed'], '');
  const url = getPathFromAlternativePaths(entity);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="TaxonomyTermThemeTeaser__content">
        <div className="TaxonomyTermThemeTeaser__imageWrapper">
          <Image
            alt={entity.getIn(['field_thumbnail', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_thumbnail', 0, 'styles', 'teaser'], '')}
            className="TaxonomyTermThemeTeaser__imageNormal"
          />
          <Image
            alt={entity.getIn(['field_thumbnail', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_thumbnail', 0, 'styles', 'large'], '')}
            className="TaxonomyTermThemeTeaser__imageMobile"
          />
        </div>
        <div className="TaxonomyTermThemeTeaser__contentWrapper">
          <h3>{title}</h3>
          {body ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body font-size--body--large"
              html={body}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default TaxonomyTermThemeTeaser;
